<template>
<div>
<ContentOverlay></ContentOverlay>
<div class="content_card" >

<ContentHeader   :title="title"  :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri" url="SupplierProjectFlowSummary" ></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<div class="content_card_content" v-if="!loading">
<TabView @update:activeIndex="activeIndexChanged">
    <TabPanel :header="$store.state.languages.lang_phrases.soru_listesi_bolumleri">
        <div class="grid">
          <div class="col-4">
            <Tree 
            :value="treesections" 
            @node-select="nodeSelected"
            v-model:selectionKeys="selectedSection"
            selectionMode="single"
            loadingMode="icon" 
            class="w-full"></Tree>
          </div>
          <div class="col-8">
            
            <Chart type="bar" :data="chartData" :options="chartOptions" />
          </div>
        </div>
    </TabPanel>
    <TabPanel :header="$store.state.languages.lang_phrases.soru_siniflari">
      <div class="grid">
          <div class="col-4">
            <Tree 
            :value="treeclasses" 
            @node-select="classCodeSelected"
            v-model:selectionKeys="selectedClass"
            selectionMode="single"
            loadingMode="icon" 
            class="w-full"></Tree>
          </div>
          <div class="col-8">
            <Chart type="bar" :data="chartData" :options="chartOptions" />
          </div>
        </div>
       

    </TabPanel>
</TabView>
</div>



</div>
</div>
</template>

<script>
export default {

  name: 'SupplierProjectFlowSummaryAnalysis',

  data () {
    return {
    	loading:false,
      selectedSection:null,
      selectedClass:null,
      selectedSectionKey:null,
      selectedClassKey:null,
      flowsupplier:null,
      sections:[],
      inputfields:[],
      treesections:[],
      treeclasses:[],
      classes:[],
      chartData: {
          labels: [],
      },
      chartOptions: {
          responsive: true,
          plugins: {
              legend: {
                position: 'top',
              }
          },
          scales: {
              x: {
                  ticks: {
                      color: '#495057',
                  },
                  grid: {
                      color: '#ebedef',
                  }
              },
              y: {
                  max:100,
                  ticks: {
                      color: '#495057',
                      
                  },
                  grid: {
                      color: '#ebedef',
                  }
              }
          }
      },
    }
  },
  computed:{
    title()
    {
      if(this.flowsupplier)
      {
        let type
        {
          if(this.flowsupplier.flow.type=="self_evaluation")
          {
            type = this.$store.state.languages.lang_phrases.self_evaluation
          }
          if(this.flowsupplier.flow.type=="verification")
          {
            type = this.$store.state.languages.lang_phrases.verification
          }
        }
        return this.flowsupplier.flow.name + " - "+type
      }
      return ""
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    async resolveSection(section_id)
    {
      
      let section = this.sections.find(item=>item.id==section_id) 
      section.label = section.name
      section.key = section.id

      let child_sections = this.sections.filter(item=>item.parent_id==section_id)
      if(child_sections.length)
      {        
        section.leaf = false  
        section.children = []
        for(let child_section of child_sections)
        {
          let item = await this.resolveSection(child_section.id)
          section.children.push(item)
        }
      }
      return  section
      
    },
    async getData()
    {
      this.loading = await true      
      let data = await this.generalApiGetWithoutLoader("audit/get_sections_for_analysis/"+this.$route.params.flow_id)
      console.log("getData");
      console.log(data);
      this.flowsupplier = data.flowsupplier
      this.self_eval_flowsupplier = data.self_eval_flowsupplier
      this.verification_flowsupplier = data.verification_flowsupplier
      this.classes = data.classes
      this.sections = data.sections
      this.inputfields = data.inputfields
      for(let inputfield of this.inputfields)
      {
        let classes = []
        for(let theclass of inputfield.inputfieldclasses)
        {
          classes.push(theclass.id)
        }
        inputfield.inputfieldclasses = classes
      }
      let parentsections = this.sections.filter(item=>item.parent_id ===0)
      if(parentsections.length===1)
      {
        this.resolveSection(parentsections[0])
      }
      else
      {
        this.treesections = [
          {
            key:0,
            label:"Bölümler",
            leaf:false,
            children:[],
          }
        ]
        for(let parentsection of parentsections)
        {
          let child = await this.resolveSection(parentsection.id)
          this.treesections[0].children.push(child)
        }
        this.selectedSectionKey = 0
        this.selectedSection = {0:true}
        this.resolveChartData()

      }

      this.selectedClassKey = 0
      this.selectedClass = {0:true}

      this.treeclasses.push({
        key:0,
        label:"Bütün Sınıflar"
      })
      for(let theclass of this.classes)
      {
        this.treeclasses.push({
          key:theclass.id,
          label:theclass.name
        })
      }
      
     
      this.loading = await false
    },
    activeIndexChanged(data)
    {
      console.log(data)
      if(data===0)
      {
        this.selectedSectionKey = 0
        this.selectedSection = {0:true}
        this.resolveChartData()
      }
      if(data===1)
      {
        this.selectedClassKey = 0
        this.selectedClass = {0:true}
        this.resolveClassChartData()
      }

    },
    sectionsExpand(data)
    {
      console.log(data)
    },
    resolveChartData()
    {
      console.log(this.selectedSectionKey)
      this.chartData.labels = [] 
      this.chartData.datasets = []      
      let child_sections = []
      let child_inputfields = []
      if(this.selectedSectionKey===0)
      {
        child_sections = this.sections.filter(item=>item.parent_id == 0)        
      }
      else
      {
        child_sections = this.sections.filter(item=>item.parent_id == this.selectedSectionKey)
      }

      child_inputfields = this.inputfields.filter(item=>item.inputfieldsection_id==this.selectedSectionKey)    


      //if self eval and verification
      if(this.self_eval_flowsupplier && this.verification_flowsupplier)
      {

        if(child_sections.length)      
        {
          this.chartData.datasets.push({
            label:"Öz Değerlendirme",
            backgroundColor: '#7e2f8d',
            data: []
          })
          this.chartData.datasets.push({
            label:"Doğrulama",
            backgroundColor: '#352f8d',
            data: []
          })
        }

        if(child_inputfields.length)      
        {
          this.chartData.datasets.push({
            label:"Öz Değerlendirme",
            backgroundColor: '#dee2e6',
            data: []
          })

          this.chartData.datasets.push({
            label:"Doğrulama",
            backgroundColor: '#352f8d',
            data: []
          })
        }

        for(let child_section of child_sections)
        {
          this.chartData.labels.push(child_section.name)
          if(child_section.selfevaluationresult)
          {
            let section_point = (100/child_section.points)*child_section.selfevaluationresult.points
            this.chartData.datasets[0].data.push(section_point)
          }
          if(child_section.verificationresult)
          {
            let ver_section_point = (100/child_section.points)*child_section.verificationresult.points
            this.chartData.datasets[1].data.push(ver_section_point)
          }
          

          


        }
        for(let child_inputfield of child_inputfields)
        {
          this.chartData.labels.push(child_inputfield.name)
          if(child_inputfield.selfevaluationresult)
          {
            let inputfield_point = (100/child_inputfield.points)*child_inputfield.selfevaluationresult.points
            this.chartData.datasets[0].data.push(inputfield_point)
          }
          

          if(child_inputfield.verificationresult)
          {
            let ver_inputfield_point = (100/child_inputfield.points)*child_inputfield.verificationresult.points
            this.chartData.datasets[1].data.push(ver_inputfield_point)
          }
          
        }

      }
      //if self eval and verification

      //if single flow
      else
      {
        if(child_sections.length)      
        {
          this.chartData.datasets.push({
            label:"Bölümler",
            backgroundColor: '#7e2f8d',
            data: []
          })
        }

        if(child_inputfields.length)      
        {
          this.chartData.datasets.push({
            label:"Sorular",
            backgroundColor: '#dee2e6',
            data: []
          })
        }

        for(let child_section of child_sections)
        {
          this.chartData.labels.push(child_section.name)
          let section_point = (100/child_section.points)*child_section.results.points
          this.chartData.datasets[0].data.push(section_point)
        }
        for(let child_inputfield of child_inputfields)
        {
          this.chartData.labels.push(child_inputfield.name)
          let inputfield_point = (100/child_inputfield.points)*child_inputfield.results.points
          this.chartData.datasets[this.chartData.datasets.length-1].data.push(inputfield_point)
        }

      }
      //if single flow
      

      
      
      
    },
    resolveClassChartData()
    {
      this.chartData.labels = [] 
      this.chartData.datasets = [] 
      if(this.selectedClassKey===0)
      {
        this.chartData.datasets.push({
          label:"Bütün Sınıflar",
          backgroundColor: '#7e2f8d',
          data: []
        })
        for(let theclass of this.classes)
        {
          this.chartData.labels.push(theclass.name)
          this.chartData.datasets[0].data.push(theclass.classresult.points)

        }
      }
      else
      {
        let selected_class = this.classes.find(item=>item.id == this.selectedClassKey)
        this.chartData.datasets.push({
          label:selected_class.name,
          backgroundColor: '#7e2f8d',
          data: []
        })
        for(let inputfield of this.inputfields)
        {
          if(inputfield.inputfieldclasses.includes(this.selectedClassKey))
          {
            this.chartData.labels.push(inputfield.name)
            let class_result = inputfield.classresults.find(item=>item.inputfieldclass_id == this.selectedClassKey)
            if(class_result)
            {
              this.chartData.datasets[0].data.push(class_result.points)
            }
            else
            {
              this.chartData.datasets[0].data.push(0)
            }
            
          }
        }

      }

    },
    classCodeSelected(data)
    {
      setTimeout(()=>{
        console.log(this.selectedClass)
        this.selectedClassKey = data.key
        this.resolveClassChartData()
      },50)
    },
    nodeSelected(data)
    {      
      setTimeout(()=>{
        console.log(this.selectedSection)
        this.selectedSectionKey = data.key
        this.resolveChartData()
      },50)
      
    },
  },
}
</script>

<style lang="css" scoped>
</style>